(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-wager/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/game-wager/assets/javascripts/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.gameWager = {
  logger: new svs.core.log.Logger('numbergames:game-wager')
};

































 })(window);